export class Encargo {
    id: number;
    nome: string;
    ativo: boolean = true;
}
